import React from "react";
import { AuthConsumer } from "../../../providers/AuthProvider";

import PageLoader from "../../page-loader";
import '../../../index.scss'

export const Logout = () => (
    <AuthConsumer>
        {({ logout }) => {
            logout();
            return <div className="loading-page-container"><PageLoader /></div>;
        }}
    </AuthConsumer>
);